<template lang="pug">
  .c-highlights
    .c-highlights--loaded
      FlightTeaser(v-if='listFull' :flightLists='flightList' :dateFormat='dateFormat' :timeFormat='timeFormat')
</template>

<script>
import flightSchema from './utils/schemas/flight.js'
import FlightTeaser from '@/components/FlightTeaser.vue'
import axios from 'axios'

export default {
  name: 'Flight',
  props: ['flightData'],
  components: {
    FlightTeaser
  },
  data() {
    return {
      flightList: [],
      listFull: false,
      dateFormat: this.getDateFormat(),
      timeFormat: this.getTimeFormat()
    }
  },
  created() {
    let vm = this
    let pageType = 'undefined'
    let pageId = 'undefined'
    if (window.dataLayer.length > 0) {
      // fill up data for proper attribution
      if (window.dataLayer[0].hasOwnProperty('pageType')) {
        pageType = window.dataLayer[0].pageType
      }
      if (window.dataLayer[0].hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.dataLayer[0].pagePath
      }
      if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
        pageId = window.dataLayer[0].pagePostId
      }
    }
    if (window.gtm_tracking !== undefined && window.gtm_tracking !== null) {
      if (window.gtm_tracking.hasOwnProperty('pageType')) {
        pageType = window.gtm_tracking.pageType
      }
      if (window.gtm_tracking.hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.gtm_tracking.pagePath
      }
      if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
        pageId = window.gtm_tracking.pagePostId
      }
    }
    this.flightData.product = pageType
    this.flightData.pageid = pageId
    let searchData = flightSchema.setReturnFlightSchema(this.flightData)
    axios
      .post('https://cn.holidaypirates.group/v1.1/search', searchData, {
        headers: ''
      })
      .then(function(response) {
        if (response.data.data.ranks[0].items.length > 0) {
          vm.flightList.push(response.data)
          vm.listFull = true
        }
      })
  },
  methods: {
    getDateFormat() {
      if (this.$store.getters.getLocale === 'en-US') {
        return 'MM/DD/YYYY'
      }
      return 'DD.MM.YYYY'
    },
    getTimeFormat() {
      let timeFormat = 'HH:mm'
      return timeFormat
    }
  }
}
</script>
